import { getHarvestEntryConfig as getHarvestEntryConfigApi } from "../../../utils/api.js";

export async function getHarvestEntryConfig(siteId, cropId, orgId = null) {
  const resp = await getHarvestEntryConfigApi(siteId, cropId, orgId);
  return resp?.data?.data ?? null;
}
